export const loadCharlyTheme = (theme: string) => {
    switch (theme) {
        case 'audi':
            return import('./audi');
        case 'seat':
            return import('./seat');
        case 'skoda':
            return import('./skoda');
        case 'vw6':
            return import('./vw6');
        case 'bluelabel':
        default:
            // eslint-disable-next-line no-console
            if (theme !== 'bluelabel') console.warn(`[Charly] Unknown brand: ${theme}. Load bluelabel theme.`);
            return import('./bluelabel');
    }
};
